import { HiDocumentReport } from 'react-icons/hi';
import { TbReportAnalytics } from 'react-icons/tb';
import { TbReport } from 'react-icons/tb';
import { GiCardDraw } from 'react-icons/gi';

import { MdCalendarMonth } from 'react-icons/md';
import { SlCalender } from 'react-icons/sl';
import { BsCalendar3Week } from 'react-icons/bs';
import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';

const tiles = [
  {
    sNo: 1,
    link: '/admin/rmdescriptionlist?filter=part_number',
    isLink: true,
    icon: <GiCardDraw size="5rem" color="#343a40" />,
    p: 'RM',
    span: 'Description',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/admin/monthlyrminput',
    isLink: true,
    icon: <BsCalendar3Week size="5rem" color="#245278" />,
    p: 'Monthly RM',
    span: 'Input',
    isIcon: true,
  },
  {
    sNo: 3,
    link: '/admin/monthlyrmplanniglist',
    isLink: true,
    icon: <SlCalender size="5rem" color="#6b5858" />,
    p: 'Monthy',
    span: 'RM Planning',
    isIcon: true,
  },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text="RM Input & Planning" />
      <RenderTiles
        tilesObj={tiles}
        height="100vh"
        justify="start"
        columns="0"
      />
    </>
  );
};

export default Tiles;
